import { Component, Input, inject } from "@angular/core";
import { ThirdPartyModel } from "@models/thirdparty/ThirdpartyModel";
import { RiskLinkModel } from '@models/risk/RiskLinkModel';
import { ThirdPartyDataService } from '../services/ThirdPartyDataService';
import { RiskLinkableComponent } from '@app/risk/pages/risk-linkable/risk-linkable.component';
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/thirdparty/i18n/scope";

@Component({
    selector: 'thirdparty-risks',
    templateUrl: './thirdparty-risks.component.html',
    styleUrls: ['./thirdparty-risks.component.scss'],
    imports: [RiskLinkableComponent, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class ThirdPartyRisksComponent {
    private _DS = inject(ThirdPartyDataService);

    @Input() model: ThirdPartyModel;
    @Input() disabled;

    linked: RiskLinkModel[];
    unlinked: RiskLinkModel[];
    isLoading = true;

    load() {
        if (!this.model) {
            return;
        }

        this._DS.getRisks(this.model.OrganizationResponsibleId).subscribe(
            value => {
                this.loadData(this.model.LinkedRisks, value.sortBy("name", true));
                this.isLoading = false;
            }
        );
    }

    linkedChanged(newList: RiskLinkModel[]) {
        this.model.LinkedRisks = newList.map(x => x.id);
    }

    private loadData(linkedIds: number[], items: RiskLinkModel[]) {
        const linked = [], unlinked = [];

        for (const item of items) {
            if (linkedIds.indexOf(item.id) >= 0) {
                linked.push(item);
            } else {
                unlinked.push(item);
            }
        }
        this.linked = linked;
        this.unlinked = unlinked;
    }
}